import { render, staticRenderFns } from "./StatIcon.vue?vue&type=template&id=3a2678ad&scoped=true&"
import script from "./StatIcon.vue?vue&type=script&lang=js&"
export * from "./StatIcon.vue?vue&type=script&lang=js&"
import style0 from "./StatIcon.vue?vue&type=style&index=0&id=3a2678ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2678ad",
  null
  
)

export default component.exports